import { writable } from 'svelte/store';
import { fetchWithSession } from '../util/fetchWithSession';

export function createActivitiesStoreProject() {
  const { subscribe, set, update } = writable({
    activities: [],
    editActivityName: '',
    editActivityColor: '#f4f4f4',
    editActivityId: null,
    allActivities: [],
    toastMsg: null,
    saveSuccessful: false,
  });

  async function getAllActivities(idproject) {
    const res = await fetchWithSession(`/api/damprojects/activities?project_id=${idproject}`);
    const data = await res.json();
    const sortedActivities = data.sort((a, b) => {
      if (a.activity_name < b.activity_name) return -1;
      if (a.activity_name > b.activity_name) return 1;
      return 0;
    });
    update(state => ({
      ...state,
      allActivities: sortedActivities,
      toastMsg: '',
      saveSuccessful: false,
    }));
    return sortedActivities;
  }

  async function saveActivity(editActivityName, editActivityColor, editActivityId, idproject) {
    const endpoint = `/api/damprojects/activities${editActivityId ? `/${editActivityId}` : ''}`;
    const body = { activity_name: editActivityName, color: editActivityColor, project_id: idproject }; 

    let res = await fetchWithSession(endpoint, {
      method: (editActivityId ? 'PATCH' : 'POST'),
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    let j = await res.json();
    const newActivity = j.data;
    let message = j.message || j.error;
    let ok = j.ok;
     update((state) => {
      if (ok){
      let updatedActivities;
      if (editActivityId) {
        // Update existing activity
        updatedActivities = state.allActivities.map((activity) =>
          activity.id === editActivityId ? newActivity : activity
        );
      } else {
        // Add new activity
        updatedActivities = [...state.allActivities, newActivity];
      }
      return {
        ...state,
        allActivities: updatedActivities,
        toastMsg: message,
        saveSuccessful: ok,
      }}
      else 
        return {
        ...state,
        toastMsg: message,
        saveSuccessful: ok,
      }

      
    });
    return j;
  }

  function deleteActivity(activityid, idproject, analysisid) {
    fetchWithSession(`/api/damprojects/activity-mapping/${activityid}`, {
      method: "DELETE",
      body: JSON.stringify({
        id: activityid,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.ok) {
          update((state) => ({
            ...state,
            allActivities: state.allActivities.filter(
              (activity) => activity.id !== activityid
            ),
            toastMsg: data.message || data.error,
            saveSuccessful: data.ok,
          }));
        }
        else {
          update((state) => ({ 
            ...state,
            toastMsg: data.message || data.error,
            saveSuccessful: data.ok,
      
        }))
      }
      });
  }

  function updateActivityRegistration(previousActivityId, newActivityId, registration, updatedRegistration) {
    update((state) => {

      const updatedActivities = state.allActivities.map((activity) => {
        if (activity.id === previousActivityId) {
          return {
            ...activity,
            // activity_mapping_step_recordings: activity.activity_mapping_step_recordings.filter(
            //   (rec) => rec.id !== registration.id
            // ),
          };
        }
        if (activity.id === newActivityId) {
          const recordingExists = activity.activity_mapping_step_recordings.some(
            (rec) => rec.id === updatedRegistration.id
          );
          if (!recordingExists) {
            return {
              ...activity,
              activity_mapping_step_recordings: [
                ...activity.activity_mapping_step_recordings,
                updatedRegistration,
              ],

            };
          }
        }
        return activity;
        
      });

      return {
        ...state,
        allActivities: updatedActivities,
              toastMsg: "",
      saveSuccessful: false,
      };
    });
  }

  async function updateNodeActivity(registration, newActivityId) {
    const previousActivityId = registration.activity_id;
    const res = await fetchWithSession(
      `/api/damprojects/activity-recording-steps/${registration.id}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          activity_id: newActivityId,
        }),
      }
    );
    const data = await res.json();

    // if (data.ok && data.data) {
    //   updateActivityRegistration(previousActivityId, newActivityId, registration, data.data);
    // }

    // else {
      update(state => ({ ...state, toastMsg: data.message || data.error, saveSuccessful: data.ok }));
    //}

    return data;
  }

  async function addRecordsToActivity(listOfRecords, activityId, currentActivities) {

    console.log({ listOfRecords, activityId, currentActivities });
    // const currentActivity = currentActivities.find(
    //   (activity) => activity.id === activityId
    // );
    // const listOfRecordings =[]
    // if (!currentActivity) {
    //   //throw new Error("Activity not found");
    //    listOfRecordings = [
    //   //...currentActivity.activity_mapping_step_recordings,
    //   ...listOfRecords,
    // ];
    // }
    // else {

    //  listOfRecordings = [
    //   ...currentActivity.activity_mapping_step_recordings,
    //   ...listOfRecords,
    // ];

    const { recording_id, step_number } = listOfRecords[0];

    //const activityname = currentActivity.name;
    const res = await fetchWithSession(`/api/damprojects/activity-recording-steps`, {
      method: "POST",
      body: JSON.stringify({
        activity_id: activityId,
        recording_id: recording_id,
        step_number: step_number,
      }),
    });
    const data = await res.json();

    if (data.ok && data.data) {
      update((state) => ({
        ...state,
        // allActivities: state.allActivities.map((activity) =>
        //   activity.id === data.data.activity_id ? 
        // { ...activity, activity_mapping_step_recordings: activity.activity_mapping_step_recordings.push({
        //     recording_id: data.data.recording_id,
        //     step_number: data.data.step_number,
        //     id: data.data.id}) } : activity
        // ),
         toastMsg: data.message || data.error,
            saveSuccessful: data.ok,
      
      }));
    }
        else {
               update((state) => ({ 
            ...state,
            toastMsg: data.message || data.error,
            saveSuccessful: data.ok,
      
        }))
    }

    return data;
  }

  async function removeRecordsFromActivity(listOfRecordsToRemove, activityId, currentActivities) {
    const currentActivity = currentActivities.find(
      (activity) => activity.id === activityId
    );

    if (!currentActivity) {
      throw new Error("Activity not found");
    }

    // const listOfRecordings = currentActivity.activity_mapping_step_recordings.filter(
    //   (recording) =>
    //     !listOfRecordsToRemove.some(
    //       (toRemove) =>
    //         toRemove.recording_id === recording.recording_id &&
    //         toRemove.step_number === recording.step_number
    //     )
    // );

    let idToRemove = currentActivity.activity_mapping_step_recordings.find(rec => rec.recording_id === listOfRecordsToRemove[0].recording_id && rec.step_number === listOfRecordsToRemove[0].step_number)?.id;

    const res = await fetchWithSession(`/api/damprojects/activity-recording-steps/${idToRemove}`, {
      method: "DELETE",
      body: JSON.stringify({
      }),
    });
    const data = await res.json();
     
    // if (data.ok) {
    //   update((state) => {
    //     // const updatedActivities = state.allActivities.filter((activity) =>
    //     //   activity.id !== idToRemove
    //     // );

    //     return {
    //       ...state,
    //       //allActivities: updatedActivities,
    //     };
    //   });
    // }else {
      update((state) => ({ 
            ...state,
            toastMsg: data.message || data.error,
            saveSuccessful: data.ok,
      
        }));
      //}

    return data;
  }

  // async function getActivityByNode(selectedNode) {
  //   let currentState;
  //   const unsubscribe = subscribe(state => {
  //     currentState = state;
  //   });
  //   unsubscribe();
  //   const [nodeid, step_number] = selectedNode.split("_");

  //   if (!step_number) {
  //     return null;
  //   }

  //   for (const activity of currentState.allActivities) {
  //     const recording = activity.activity_mapping_step_recordings.find(
  //       (reg) =>
  //         reg.recording_id === nodeid &&
  //         reg.step_number === parseInt(step_number),
  //     );
  //     if (recording) {
  //       return { ...recording, activity_id: activity.id };
  //     }
  //   }
  //   return null;
  // }

  return {
    subscribe,
    set,
    update,
    getAllActivities,
    deleteActivity,
    saveActivity,
    updateNodeActivity,
    addRecordsToActivity,
    removeRecordsFromActivity,
   // getActivityByNode,
  };
}

export const activitiesStoreProject = createActivitiesStoreProject();
